<template>
  <a-dropdown v-if="currentUser && currentUser.name" placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <!-- <a-avatar size="small" src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png" class="antd-pro-global-header-index-avatar" /> -->
      <img src="@/assets/images/user/avatar.png" width="28" height="28" style="margin-right: 3px">
      <!-- <a-avatar style="backgroundColor:#87d068" icon="user" /> -->
      <span>{{ currentUser.name }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
        <a-menu-item v-if="menu" key="center" @click="handleToCenter">
          <a-icon type="user" />
          个人中心
        </a-menu-item>
        <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <a-icon type="setting" />
          个人设置
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <a-icon type="logout" />
          退出登录
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
</template>

<script>
import { Modal } from 'ant-design-vue'
import { ACCESS_TOKEN, USER_INFO } from '@/store/mutation-types'
import storage from 'store'

export default {
  name: 'AvatarDropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleToCenter () {
      this.$router.push({ path: '/account/center' })
    },
    handleToSettings () {
      this.$router.push({ path: '/account/settings' })
    },
    handleLogout (e) {
      Modal.confirm({
        title: "提示",
        content: "您确定要退出吗？",
        cancelText: '取消',
        okText: '确定',
        onOk: () => {
					storage.remove(ACCESS_TOKEN)
					storage.remove(USER_INFO)
					this.$store.commit('SET_TOKEN', '')
					this.$store.commit('SET_INFO', {})
					if(this.$route.name !== 'login') this.$router.push({ name: 'login', query: {} })
          // this.$apis.loginout().then(res => {
            // console.log('退出登录:',res)
            setTimeout(() => {
              
              if(this.$route.name != "login") this.$router.push('/account/login');
            }, 3000);
          // }).catch(err => {
            // this.$notification['error']({
            //   message: '提示',
            //   description: err.msg,
            //   duration: 4
            // })
          // })
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
</style>
